import React from "react";
import ReactDOM from "react-dom";
import { Paper, TextField } from '@mui/material';

export default function Root(props) {

  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    padding: '8px'
  }}>
      <TextField 
        label="Text field"
        size="small" />
      {props.name} is mounted!
      <p>This is a live editing field</p>

      <a href="/shirt">You need a shirt</a>
    </div>;
}
